import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import Advertising from '../Advertising';
import PropTypes from 'prop-types';
import AdvertisingConfigPropType from './utils/AdvertisingConfigPropType';
import AdvertisingContext from '../AdvertisingContext';
import equal from 'fast-deep-equal';

var AdvertisingProvider = /*#__PURE__*/function (_Component) {
  _inherits(AdvertisingProvider, _Component);

  var _super = _createSuper(AdvertisingProvider);

  function AdvertisingProvider(props) {
    var _this;

    _classCallCheck(this, AdvertisingProvider);

    _this = _super.call(this, props);

    _this.initialize();

    _this.state = {
      activate: _this.advertising.activate.bind(_this.advertising),
      config: _this.props.config,
      isInitialSetupComplete: false
    };
    return _this;
  }

  _createClass(AdvertisingProvider, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.advertising.isConfigReady() && this.props.active)) {
                  _context.next = 4;
                  break;
                }

                _context.next = 3;
                return this.advertising.setup();

              case 3:
                // eslint-disable-next-line react/no-did-mount-set-state
                this.setState({
                  isInitialSetupComplete: true
                });

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "componentDidUpdate",
    value: function () {
      var _componentDidUpdate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(prevProps) {
        var _this$props, config, active, isConfigReady;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this.advertising) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                _this$props = this.props, config = _this$props.config, active = _this$props.active;
                isConfigReady = this.advertising.isConfigReady(); // activate advertising when the config changes from `undefined`

                if (!(!isConfigReady && config && active)) {
                  _context2.next = 11;
                  break;
                }

                this.advertising.setConfig(config); // eslint-disable-next-line react/no-did-update-set-state

                _context2.next = 8;
                return this.advertising.setup();

              case 8:
                // Due to setup being async, it is possible for teardown to have happened and this.advertising being null here
                if (this.advertising) {
                  // eslint-disable-next-line react/no-did-update-set-state
                  this.setState({
                    activate: this.advertising.activate.bind(this.advertising),
                    config: this.advertising.config
                  });
                }

                _context2.next = 20;
                break;

              case 11:
                if (!(isConfigReady && !equal(prevProps.config, config))) {
                  _context2.next = 20;
                  break;
                }

                _context2.next = 14;
                return this.teardown();

              case 14:
                if (!active) {
                  _context2.next = 20;
                  break;
                }

                this.initialize();

                if (!this.advertising.isConfigReady()) {
                  _context2.next = 19;
                  break;
                }

                _context2.next = 19;
                return this.advertising.setup();

              case 19:
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                  activate: this.advertising.activate.bind(this.advertising),
                  config: this.advertising.config
                });

              case 20:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function componentDidUpdate(_x) {
        return _componentDidUpdate.apply(this, arguments);
      }

      return componentDidUpdate;
    }()
  }, {
    key: "componentWillUnmount",
    value: function () {
      var _componentWillUnmount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(this.props.config && this.state.isInitialSetupComplete)) {
                  _context3.next = 3;
                  break;
                }

                _context3.next = 3;
                return this.teardown();

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function componentWillUnmount() {
        return _componentWillUnmount.apply(this, arguments);
      }

      return componentWillUnmount;
    }()
  }, {
    key: "teardown",
    value: function () {
      var _teardown = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var _this$advertising;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this.setState({
                  activate: function activate() {},
                  config: null
                });
                _context4.next = 3;
                return (_this$advertising = this.advertising) === null || _this$advertising === void 0 ? void 0 : _this$advertising.teardown();

              case 3:
                this.advertising = null;

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function teardown() {
        return _teardown.apply(this, arguments);
      }

      return teardown;
    }()
  }, {
    key: "initialize",
    value: function initialize() {
      var _this$props2 = this.props,
          config = _this$props2.config,
          plugins = _this$props2.plugins,
          onError = _this$props2.onError;
      this.advertising = new Advertising(config, plugins, onError);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          activate = _this$state.activate,
          config = _this$state.config;
      return /*#__PURE__*/React.createElement(AdvertisingContext.Provider, {
        value: {
          activate: activate,
          config: config
        }
      }, this.props.children);
    }
  }]);

  return AdvertisingProvider;
}(Component);

export { AdvertisingProvider as default };
AdvertisingProvider.propTypes = {
  active: PropTypes.bool,
  config: AdvertisingConfigPropType,
  children: PropTypes.node,
  onError: PropTypes.func,
  plugins: PropTypes.arrayOf(PropTypes.shape({
    setupPrebid: PropTypes.func,
    setupGpt: PropTypes.func,
    teardownPrebid: PropTypes.func,
    teardownGpt: PropTypes.func
  }))
};
AdvertisingProvider.defaultProps = {
  active: true
};